'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var reactRouterDom = require('react-router-dom');
var useReturns = require('../../hooks/useReturns.js');
var generated = require('../../graphql/generated.js');
var pudoMethod = require('../../transformers/pudoMethod.js');
var ReturnsLayout = require('../Layout/ReturnsLayout.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const PrinterlessInfoPage = () => {
  const [shipment, setShipment] = React.useState();
  const [type, setType] = React.useState();
  const [email, setEmail] = React.useState();
  const [providerMoniker, setProviderMoniker] = React.useState();
  const [location, setLocation] = React.useState();
  const {
    client,
    initUnauthenticatedClient,
    moniker
  } = useReturns["default"]();
  const [searchParams] = reactRouterDom.useSearchParams();
  const shippingLabelInfoToken = decodeURIComponent(searchParams.get('return_id') || '');
  const {
    data,
    loading,
    error
  } = generated.useGetShippingLabelInfoQuery({
    client: client ?? initUnauthenticatedClient(),
    variables: {
      shippingLabelInfoToken,
      retailerMoniker: moniker ?? ''
    },
    onCompleted: () => {
      var _selectedPudoOption$s;
      if (!data || !data.getShippingLabelInfo) return;
      const {
        returnLabels,
        items,
        selectedPudoOption,
        obfuscatedCustomer,
        carrierMoniker
      } = data.getShippingLabelInfo;
      setShipment({
        returnLabels,
        items
      });
      setType(pudoMethod.getPudoMethodName(selectedPudoOption));
      setEmail((obfuscatedCustomer === null || obfuscatedCustomer === void 0 ? void 0 : obfuscatedCustomer.email) ?? '');
      setProviderMoniker(carrierMoniker ?? '');
      setLocation((_selectedPudoOption$s = selectedPudoOption.selectedDropOff) === null || _selectedPudoOption$s === void 0 ? void 0 : _selectedPudoOption$s.dropOffLocation);
    }
  });
  return /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      margin: '0.5rem'
    }
  }, /*#__PURE__*/React__default["default"].createElement(ReturnsLayout["default"], {
    confirmation: {
      error,
      loading,
      shipment,
      type,
      providerMoniker,
      email,
      location,
      alternateEmailToggle: false
    }
  }));
};

exports["default"] = PrinterlessInfoPage;
